import {Component, ContentChild, EventEmitter, HostListener, Input, Output} from "@angular/core";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {FUIIconComponent} from "../../../icons/icon/icon.component";

@Component({
    animations: [
        trigger("fade", [
            state("void", style({
                opacity: 0
            })),
            state("true", style({
                opacity: 1
            })),
            transition("* => *", animate("250ms 0s ease"))
        ])
    ],
    host: {
        "fade": "true"
    },
    selector: "fui-key",
    styleUrls: ["./key.component.scss"],
    templateUrl: "./key.component.html",
    standalone: false
})
export class FUIKeyComponent {
    @ContentChild(FUIIconComponent) public icon: FUIIconComponent;
    @Output() public key: EventEmitter<Event>;
    @Input() title: string;

    constructor() {
        this.key = new EventEmitter<Event>();
    }

    /**
     * Emit the interaction of the host
     * @param {Event} event
     */
    @HostListener("click", ["$event"])
    public press(event: Event): void {
        this.key.emit(event);
    }
}
